import { Button, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

class Props {
    pattern: string;
    cancel: () => void;
    save: (newPattern:string) => void;
    updatePattern: (newPattern: string) => void;
    isForNew?: boolean;
    
}
const UpdateTarget = ({pattern, cancel,save, isForNew,updatePattern} : Props) => {

    const [newPattern, setNewPattern] = useState("-----");
    const [nextIdx, setNextIdx]= useState(0);

    const getTextForTarget = (target: number, pattern: string) => {
        if (!pattern || pattern.length < target-1)
            return "";

        return pattern[target-1];
    }

    useEffect(() => {
        updatePattern(newPattern);
    },[newPattern]);

    const targets = [1,2,3,4,5];

    const setCharAt = (str: string,index : number,chr : string)  => {
        if(index > str.length-1) return str;
        return str.substring(0,index) + chr + str.substring(index+1);
    }

    return <Stack direction={"column"} spacing={2}>
        <Typography variant='body2'>Click targets in order of shots</Typography>
    <Stack direction={"row"} spacing={2}>
                {targets.map((x,idx) => {
                    return <div key={"tkey_"+idx} style={{cursor: 'pointer', width:50, height: 50}} className='circle' onClick={(ev) => {
                        
                        let t = newPattern;
                        t=setCharAt(t,idx,(nextIdx+1)+"");
                        setNewPattern(t);
                        setNextIdx(nextIdx+1);
                    }}>{getTextForTarget(x,newPattern)}</div>
                })}
                {!isForNew &&<><Button onClick={() => {save(newPattern);}}>Save</Button>
                <Button onClick={() => {cancel();}}>Cancel</Button></>}
    </Stack>
    
    </Stack>;
}

export default UpdateTarget;